/**
 * Environment configuration
 * Centralizes all environment variables with type safety.
 *
 * IMPORTANT: Never add an AI provider key/base URL/model here. Those are
 * server-side Supabase Edge Function secrets only (set via `supabase secrets
 * set`), never a VITE_-prefixed, client-bundle-exposed variable — see
 * research.md §4 and plan.md's Constraints.
 */

export const env = {
  // Supabase
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',

  // App
  appName: import.meta.env.VITE_APP_NAME || 'Decixa B2B',
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:3000',

  // Environment
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
